import { useAuth } from '@clerk/clerk-react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { OnboardingGuard } from './OnboardingGuard'

export default function ProtectedRoute() {
  const { isSignedIn, isLoaded } = useAuth()
  const location = useLocation()

  // Show loading spinner while Clerk is initializing
  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[hsl(var(--color-4))]" />
      </div>
    )
  }

  if (!isSignedIn) {
    return <Navigate to="/" state={{ from: location }} replace />
  }

  return (
    <OnboardingGuard>
      <Outlet />
    </OnboardingGuard>
  )
}
